import React, { useEffect, useState } from "react";
import "./Hero.css";
import ProfileCard from "../effects/ProfileCard/ProfileCard";
import DarkVeil from "../effects/DarkVeil/DarkVeil";

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    setIsVisible(true);

    const timer = setTimeout(() => {
      const items = document.querySelectorAll(".tech-icon");
      items.forEach((item, index) => {
        setTimeout(() => {
          item.classList.add("animate");
        }, index * 100);
      });
    }, 1000);

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className={`hero-section ${isVisible ? "visible" : ""}`} id="home">
      <div className="darkveil-wrapper">
        <DarkVeil />
      </div>

      <div className="hero-content">
        <div className="hero-text-container">
          <div className="name-container">
            <h1 className="hero-name">
              <br />

              <span className="name-part">RISHI&nbsp;</span>
              <span className="name-part"> SHINDE</span>
              <div className="title">
                FRONT END DEVELOPER | FULL STACK DEVELOPER | BACKEND DEVELOPER
              </div>
            </h1>
            <br />
            <br />
            <div className="hero-highlight"></div>
          </div>

          <p className="hero-description">
            I'm a{" "}
            <span className="highlight">
              pre-final year B.Tech in Computer Science and Engineering
            </span>{" "}
            student with expertise in{" "}
            <span className="highlight">full-stack web</span> and{" "}
            <span className="highlight">mobile development</span>. Proficient in
            the <span className="highlight">MERN stack</span>,{" "}
            <span className="highlight">Java</span>,{" "}
            <span className="highlight">Python</span>, and{" "}
            <span className="highlight">Android development</span>. Strong{" "}
            <span className="highlight">problem-solving skills</span> with
            experience in building{" "}
            <span className="highlight">scalable applications</span>.
          </p>

          <div
            className="contact-icons"
            style={{ display: "flex", gap: "1.5rem", marginTop: "1.5rem" }}
          >
            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/rishishinde2003/"
              target="_blank"
              rel="noopener noreferrer"
              title="LinkedIn"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 48 48"
              >
                <path
                  fill="#0288D1"
                  d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
                ></path>
                <path
                  fill="#FFF"
                  d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
                ></path>
              </svg>
            </a>

            {/* GitHub */}
            <a
              href="https://github.com/Rishishinde08"
              target="_blank"
              rel="noopener noreferrer"
              title="GitHub"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
              >
                <path
                  fill="#b6c9d6"
                  d="M38.5,20c0,10.299-8.391,18.5-18.5,18.5C9.892,38.5,1.5,30.299,1.5,20S9.701,1.5,20,1.5 S38.5,9.701,38.5,20z"
                ></path>
                <path
                  fill="#fff"
                  d="M33.171,19.24c0,2.306-1.191,5.51-3.148,7.102c-1.582,1.289-3.672,1.695-6.034,1.823 
        c0.888,0.539,1.479,1.515,1.479,2.629v7.636C23.979,38.8,22.429,39,20.832,39c-1.582,0-3.127-0.195-4.606-0.565v-5.017 
        c-0.642,0.2-1.484,0.318-2.568,0.262c-3.595-0.19-4.108-2.372-4.683-3.913c-0.58-1.541-2.378-1.736-2.121-2.372 
        c1.241-0.426,2.215-0.02,2.874,0.482c0.523,0.398,0.887,0.961,1.131,1.571c0.279,0.697,1.02,1.86,2.86,1.86 
        c1.299,0,2.069-0.303,2.511-0.601c0.026-1.089,0.621-2.033,1.494-2.552c-2.506-0.159-4.704-0.632-6.321-2.039 
        c-1.797-1.561-2.881-4.678-2.881-6.876c0-1.833,0.755-4.093,2.049-5.515c0.041-0.041,0.077-0.087,0.128-0.128 
        c-0.298-0.894-0.642-2.66,0.195-4.822c2.49-0.046,4.457,1.315,5.258,1.972c1.448-0.334,3.03-0.493,4.694-0.493 
        c1.705,0,3.333,0.149,4.806,0.493c0.801-0.657,2.773-2.018,5.258-1.967c0.873,2.249,0.467,4.072,0.164,4.925 
        C32.401,15.229,33.171,17.391,33.171,19.24z"
                ></path>
                <path
                  fill="#788b9c"
                  d="M20,39C9.523,39,1,30.477,1,20C1,9.346,9.346,1,20,1s19,8.346,19,19C39,30.477,30.477,39,20,39z 
        M20,2C9.907,2,2,9.907,2,20c0,9.925,8.075,18,18,18s18-8.075,18-18C38,9.907,30.093,2,20,2z"
                ></path>
              </svg>
            </a>

            {/* Email */}
            <a href="mailto:rishikesh2003@gmail.com" title="Email">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 48 48"
              >
                <path
                  fill="#4caf50"
                  d="M45,16.2l-5,2.75l-5,4.75L35,40h7c1.657,0,3-1.343,3-3V16.2z"
                ></path>
                <path
                  fill="#1e88e5"
                  d="M3,16.2l3.614,1.71L13,23.7V40H6c-1.657,0-3-1.343-3-3V16.2z"
                ></path>
                <polygon
                  fill="#e53935"
                  points="35,11.2 24,19.45 13,11.2 12,17 13,23.7 24,31.95 35,23.7 36,17"
                ></polygon>
                <path
                  fill="#c62828"
                  d="M3,12.298V16.2l10,7.5V11.2L9.876,8.859C9.132,8.301,8.228,8,7.298,8h0C4.924,8,3,9.924,3,12.298z"
                ></path>
                <path
                  fill="#fbc02d"
                  d="M45,12.298V16.2l-10,7.5V11.2l3.124-2.341C38.868,8.301,39.772,8,40.702,8h0C43.076,8,45,9.924,45,12.298z"
                ></path>
              </svg>
            </a>
          </div>

          <div className="hero-buttons">
            <a href="mailto:rishikesh2003@gmail.com">
              <button className="btn primary">
                <span>Hire Now</span>
                <div className="arrow-wrapper">
                  <div className="arrow"></div>
                </div>
              </button>
            </a>

            <a
              href="https://drive.google.com/file/d/1lAiLbkNHtjB2y9dQfgQANin6tEo1V82K/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="btn secondary">
                <span>Download CV</span>
                <svg className="download-icon" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 15V3M12 15L8 11M12 15L16 11M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </a>
          </div>
        </div>

        <div className="profile-card-wrapper">
          <ProfileCard
            name="Rishi Shinde"
            title="Full Stack Developer"
            handle="rishi.codes"
            status="Online"
            contactText="Contact Me"
            avatarUrl="/rishi.png"
            showUserInfo={true}
            enableTilt={true}
            enableMobileTilt={false}
            onContactClick={() => console.log("Contact clicked")}
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
